import http from "@/services/http";
import type { DashboardStats } from "@/models/operation.model";

class DashboardService {
  async getAdminDashboard(): Promise<DashboardStats> {
    return http.get<DashboardStats>("/admin/stats/dashboard");
  }

  async getProviderDashboard(): Promise<DashboardStats> {
    return http.get<DashboardStats>("/provider/stats/dashboard");
  }
}

export default new DashboardService();
